export enum ModalBodyType {
  FEED = 'MESSAGE_CENTER_FEED',
  DETAILS = 'MESSAGE_DETAILS',
}

export enum ModalStyleVariant {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}
